var _g, _g2, _g3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.708,
    height: 16.708,
    viewBox: "0 0 16.708 16.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    d: "M14.261,2.447A8.354,8.354,0,1,0,2.447,14.261,8.354,8.354,0,1,0,14.261,2.447ZM8.354,15.713a7.359,7.359,0,1,1,7.359-7.359A7.368,7.368,0,0,1,8.354,15.713Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(3.448 5.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    d: "M108.749,170.291a2.091,2.091,0,0,0-2.953,0,.5.5,0,1,0,.7.7,1.1,1.1,0,0,1,1.547,0,.5.5,0,1,0,.7-.7Z",
    transform: "translate(-105.65 -169.681)",
    fill: "currentColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3237",
    "data-name": "Group 3237",
    transform: "translate(10.015 5.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3236",
    "data-name": "Group 3236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M310.011,170.291a2.091,2.091,0,0,0-2.953,0,.5.5,0,1,0,.7.7,1.1,1.1,0,0,1,1.547,0,.5.5,0,1,0,.7-.7Z",
    transform: "translate(-306.912 -169.681)",
    fill: "currentColor"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25326",
    "data-name": "Path 25326",
    d: "M1.273-20.216a4.564,4.564,0,0,1,4.238-2.392c3.168,0,3.782,2.392,3.782,2.392",
    transform: "translate(3.223 32.672)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplain);
export default __webpack_public_path__ + "static/media/complain.2a3c6b665a2c7f6d476a58debfcf0f31.svg";
export { ForwardRef as ReactComponent };